var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0_756_372)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_756_372",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_756_372",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_756_372",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABJElEQVR4nO2TMUoDYRCFf9FeEAl4FZvFGY0nCCLuTKNo4UEs4nGstRAEK3slR4iNWEQCTzaISP51ydrMLr4PXv++eUxKhBBCCMnBaLQOlwuYPsL0A67oSN7gcg+Xs6pjs8T5/iZMbztQGs2RB5wOt+olUlqDyU18SV1dpig2chHTo/hy2i6lXNaIyF14MW8Zk6c6kffwYt42MstFwkv9Lek3kdQTQJGOAS7St0XQsySKePwK4CIef3lwEY+/NriIx18YXOSL6MtykWWiL8tFloHLPPq6aB2Z5yImk/hi2i4mk5pF9Lp/IjrORU4Od2AyDS/nK+e16pyJLGTKvd1eyJhMq661Et8yx8U2XK7g+hJe2H9GZjB5XrxAeTBolCCEEEL+K5/P5bojah6A7wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCards);
export default __webpack_public_path__ + "static/media/BankCards.f343329e611b4d724a84bf55d9604ecc.svg";
export { ForwardRef as ReactComponent };